import styled from '@emotion/styled'
import { fadeInOutMs } from '../Landing/utils'
import { CSSObject, keyframes } from '@emotion/react'
import { StyledHTMLElement } from 'shop/theme/types'

export const Icon = styled.div(() => ({
  '> svg': {
    width: '18px',
    height: '18px',
    fill: '#000'
  }
}))

export const overlayOpenAnim = (isOpen: boolean, fadeMs = fadeInOutMs) => ({
  animation: isOpen
    ? `${fadeIn} ${fadeMs}ms linear forwards`
    : `${fadeOut} ${fadeMs}ms linear forwards`
})

export const slideUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(200px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`

export const fadeIn = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1 } 
`

export const fadeOut = keyframes`
  0% { opacity: 1 }
  100% { opacity: 0 } 
`

export const SendAgain = styled.span<StyledHTMLElement>(
  (): CSSObject => ({
    textDecoration: 'underline',
    color: 'black',
    fontWeight: 600
  })
)

export const ErrorMessage = styled.p<StyledHTMLElement>(({ theme }) => ({
  margin: '2px 12px',
  fontSize: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: '2px',
  color: theme.colors['state'].error[5],

  '& svg': {
    aspectRatio: '1/1',
    width: '15px'
  },

  '& span': {
    cursor: 'pointer',
    textDecoration: 'underline'
  }
}))

export const LineBreak = styled.hr<StyledHTMLElement & { height?: string }>(
  ({ height = '1px' }) => ({
    backgroundColor: '#EFEFF0',
    border: '0',
    height: height,
    margin: 0
  })
)

export const VerticalBreak = styled.div<
  StyledHTMLElement & { margin?: string }
>(({ margin }) => ({
  borderLeft: `1px solid #BEBEBE`,
  ...(margin && { margin })
}))

export const StrikethroughPrice = styled.span(() => ({
  textDecoration: 'line-through'
}))

// Types for determining sticky card type on shop page
export type ShopCardType = typeof PRODUCT_LIST | typeof SHOP_INFO
export const SHOP_INFO = 'SHOP_INFO'
export const PRODUCT_LIST = 'PRODUCT_LIST'

// iOS GPU rendering fix prevents flickering
export const iosGpuRenderFixProperties: CSSObject = {
  backfaceVisibility: 'hidden', // force iOS GPU render
  WebkitBackfaceVisibility: 'hidden', // force iOS GPU render
  MozBackfaceVisibility: 'hidden', // force iOS GPU render
  transform: 'translate3d(0, 0, 0)', // force iOS GPU render
  WebkitTransform: 'translate3d(0, 0, 0)', // force iOS GPU render
  MozTransform: 'translate3d(0, 0, 0)' // force iOS GPU render
}

export const Header = styled.h1<StyledHTMLElement>(({ theme }) => ({
  fontSize: theme.fontSizes[3],
  marginTop: 0,
  color: theme.colors.primary,
  marginBottom: 0,
  [theme.mediaQueries.viewport7]: {
    fontSize: theme.fontSizes[5]
  }
}))
